module.exports = __webpack_public_path__ + "static/media/fast.7b7512cc.png";